import { render, staticRenderFns } from "./evaluations.vue?vue&type=template&id=6fccf676&scoped=true&"
import script from "./evaluations.vue?vue&type=script&lang=ts&"
export * from "./evaluations.vue?vue&type=script&lang=ts&"
import style0 from "./evaluations.vue?vue&type=style&index=0&id=6fccf676&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fccf676",
  null
  
)

export default component.exports